import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

const StyledGrid = styled(Grid)({
  flexGrow: 1,
  margin: 'auto',
  width: '100%',
});

function GridContainer({ children, className, ...rest }) {
  return (
    <StyledGrid item container {...rest} className={className}>
      {children}
    </StyledGrid>
  );
}

export default GridContainer;
